import React from 'react'
// import 'bootstrap/dist/css/bootstrap.css';


function Header() {
  return (
    <div className='bg-danger'>
    <center><h1 className='text-white player'>Youtube Player&nbsp;<span style={{fontSize:"small"}} className='d-inline fontVersion'>v2.0 by <span className='nitin'>Nitin Singh</span></span></h1></center>
    </div>
  )
}

export default Header